import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import jwtEncode from "jwt-encode";
import { UNO_URL } from "../Server";
import { NavigatorIcon, defaultLogo } from "../assets/Icons";

const AppDrawer = () => {
  const [applications, setApplications] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const fetchApplications = async () => {
    try {
      const token = localStorage.getItem("unoToken");
      const { data } = await axios.get(`${UNO_URL}/api/application/mine`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setApplications(data?.data);
    } catch (error) {
      console.error("Failed to fetch applications:", error);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  const handleAppClick = (app) => {
    const token = localStorage.getItem("unoToken");
    if (token && app?.channel?.origins?.[0]?.url) {
      const encodedToken = jwtEncode({ token }, "");
      const link = app.channel.origins[0].url;
      const finalUrl = link.includes("apps.simulanis.io") ? link : `${link}?referrer=${encodedToken}`;
      window.location.href = finalUrl;
    }
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="dropdown navigator" ref={dropdownRef}>
      <div className="profile-info dropdown-toggle" onClick={toggleDropdown} aria-expanded={isOpen}>
        <NavigatorIcon />
      </div>
      {isOpen && (
        <div className="dropdown-menu appdrawerlist show">
          <div className="menu-long">
            <div className={applications.length > 2 ? "menubg extraspace" : "menubg"}>
              {applications.map((app) => (
                <div key={app.uuid} className="appshere" onClick={() => handleAppClick(app)}>
                  <img
                    src={app.icon || defaultLogo}
                    onError={(e) => {
                      e.target.src = defaultLogo;
                      e.onerror = null;
                    }}
                    alt=""
                    referrerPolicy="no-referrer"
                  />
                  <p>{app.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppDrawer;
